import React, { useEffect, useMemo, useState } from "react";
import "./esim-booking-detail-page.scss";
import { CountdownText } from "../../ui/commons/CountdownText";
import { useParams, Link } from "react-router-dom";
import { get } from "../../../utils/request";
import Navbar from "../../Navbar/Navbar";
import { Typography, Button, Divider, Breadcrumb } from 'antd';
import {
  QrcodeOutlined,
  QuestionCircleOutlined,
} from '@ant-design/icons';
import KycDialog from "../../ui/commons/KycDialog";
import EsimLocationDialog from "../../ui/commons/EsimLocationDialog";
import { toast } from "react-toastify";
import {post} from "../../../utils/request";
import Footer from "../../Footer/Footer";
import { customerOrderNumber, formatBookingDate } from "../bookingDisplay";
import { getTimezone } from "../../../utils/context";

const { Text, Title } = Typography;


const loadRazorpayScript = () =>
  new Promise((resolve) => {
    if (window.Razorpay) return resolve(true);
    const script = document.createElement("script");
    script.src = "https://checkout.razorpay.com/v1/checkout.js";
    script.onload = () => resolve(true);
    script.onerror = () => resolve(false);
    document.body.appendChild(script);
  });


export const EsimBookingDetailPage = ({  }) => {
  const { bookingId } = useParams();

  const [isLoading, setIsLoading] = useState(false);
  const [order, setOrder] = useState(null);

  const [showKyc, setShowKyc] = useState(false);
  const [kycPrompt, setKycPrompt] = useState(null);

  const [paying, setPaying] = useState(false);

  useEffect(() => {
    fetchBookingDetail();
  }, [bookingId]);

  const fetchBookingDetail = async () => {
    try {
      setIsLoading(true);
      const result = await get(`/order/esim/${bookingId}`);
      setOrder(result);
      setIsLoading(false);
    } catch (error) {
      console.log(error);

      setIsLoading(false);
    }
  };

  const paymentNotify = async (paymentId) => {
    try {
      if (!paymentId) return;
      await post(`/payment/${paymentId}/notify`);
    } catch {
      // non-blocking
    }
  };

  const onPay = async () => {
    if (paying) return;

    setPaying(true);
    try {
      const paymentResult = await post("/payment/pay", {
        orderId: bookingId,
        serviceType: "esim",
      });

      if (paymentResult.isHit) {
        hitRule(paymentResult.riskResult);
        return;
      }

      const payResult = paymentResult?.payResult;
      if (!payResult) {
        toast.error("Something went wrong, please try again.");
        return;
      }

      const options = {
        key: payResult.appkey,
        order_id: payResult.providerOrderId,
        amount: payResult.amount,
        currency: payResult.currency,
        name: payResult.name,
        description: payResult.description,
        timeout: payResult.timeout,
        handler: async () => {
          await paymentNotify(payResult.paymentId);
          await fetchBookingDetail();
          setPaying(false);
        },
        prefill: {
          name: payResult.fullName,
          email: payResult.email,
          contact: payResult.contact,
        },
        theme: { color: "#3399cc" },
        // callback_url: `/my-bookings/esim/${orderId}`,
        // redirect: true
      };

      if (!window.Razorpay) {
        const loaded = await loadRazorpayScript();
        if (!loaded) {
          toast.error("Payment system failed to load. Please try again.");
          return;
        }
      }

      var rzp = new window.Razorpay(options)

      rzp.on('payment.failed', function (response){
        toast.error("Payment failed");
      });

      rzp.open();
    } catch (err) {
      console.error("Payment Error:", err);
      toast.error("Something went wrong, please try again.");
    } finally {
      setPaying(false);
    }
  };

  function hitRule(riskResult) {
    const actionType = riskResult.action.type;
    if ('redirect_to_kyc' === actionType) {
      performKYC(riskResult);
    } else if ('block_checkout' === actionType) {
      //TODO block checkout
    }
  }

  function performKYC(riskResult) {
    setKycPrompt(riskResult.message);
    setShowKyc(true);
  }

  if (isLoading) {
    return (
      <div className="esim-page">
        <div className="esim-page__loading">
          <div className="spinner" />
        </div>
      </div>
    );
  }

  //   if (error) {
  //     return (
  //       <div className="esim-page">
  //         <header className="esim-page__header">
  //           <button className="esim-page__back-btn" onClick={onBack}>
  //             ←
  //           </button>
  //           <h1 className="esim-page__title">eSim Booking Detail</h1>
  //         </header>
  //         <div className="esim-page__error">
  //           <p>{error}</p>
  //           {onRetry && (
  //             <button className="btn btn--primary" onClick={onRetry}>
  //               Retry
  //             </button>
  //           )}
  //         </div>
  //       </div>
  //     );
  //   }

  //   if (!order) {
  //     return (
  //       <div className="esim-page">
  //         <header className="esim-page__header">
  //           <button className="esim-page__back-btn" onClick={onBack}>
  //             ←
  //           </button>
  //           <h1 className="esim-page__title">eSim Booking Detail</h1>
  //         </header>
  //         <div className="esim-page__not-found">Order not found</div>
  //       </div>
  //     );
  //   }

  return (
    <>
      <Navbar />
      <div className="esim-layout-content">
        <section className="container p-0">
          <div className="esim-page">
            <div className="breadcrumb">
              <Breadcrumb
                items={[
                  {
                    title: (
                      <Link to="/my-profile" state={{ activeTab: "bookings" }}>
                        My Bookings
                      </Link>
                    ),
                  },
                  {
                    title: (
                      <Link to="/my-profile" state={{ activeTab: "bookings", tab: "esim" }}>
                        Travel eSIM
                      </Link>
                    ),
                  },
                  {
                    title: "Booking Details",
                  },
                ]}
              />
            </div>
            <header className="esim-page__header">
              <div>
                <Title level={2} style={{ margin: 0 }}>
                  Travel eSIM Booking
                </Title>
                <Text className="booking-detail-subtitle">
                  {order ? `Order ${customerOrderNumber(order)}` : "Review your booking, usage, and activation QR."}
                </Text>
              </div>
              {!!order?.status && !order?.kycInfo && (
                <span className="booking-detail-status">{order.status}</span>
              )}
            </header>

            {isLoading && (
              <div className="esim-page__loading">
                <div className="spinner" />
              </div>
            )}

            {!isLoading && !order && (
              <div className="esim-page__not-found">Order not found</div>
            )}

            {!isLoading && !!order && (
              <div className="esim-page-layout">
                <div className="esim-page__body">
                  {!!order.kycInfo && (
                    <VerificationCard
                      kycInfo={order.kycInfo}
                      orderId={order.orderId}
                      onPay={onPay}
                    />
                  )}

                  {/* Payment Section */}
                  {order.status === "Awaiting payment" &&
                    order.paymentInfo?.timeout > 0 &&
                    order.paymentInfo &&
                    !order.kycInfo && (
                      <PaymentCard
                        paymentInfo={order.paymentInfo}
                        orderId={order.orderId}
                        onPay={onPay}
                        onExpired={() => fetchBookingDetail()}
                      />
                    )}

                  {/* Booking Info */}
                  <OrderHeaderCard order={order} />

                  {/* Plan Info */}
                  <PlanInfoCard order={order} />

                  {/* eSIM Info */}
                  {!!order?.esimProfile && (
                    <EsimInfoCard
                      order={order}
                      esimProfile={order.esimProfile}
                      percent={
                        !!order.totalVolumeInGB && order.totalVolumeInGB > 0
                          ? Math.min(
                              1,
                              order.usedVolumeInGB / order.totalVolumeInGB
                            )
                          : 0
                      }
                    />
                  )}

                  {!!order?.esimProfile && (
                    <EsimActivationCard esimProfile={order.esimProfile} />
                  )}
                </div>
                <div className="esim-page-right-seciton">
                  <OrderPriceCard order={order} />
                </div>
              </div>
            )}
          </div>

          <KycDialog
            isOpen={showKyc}
            onOk={() => setShowKyc(false)}
            onCancel={() => setShowKyc(false)}
            prompt={kycPrompt}
          />
        </section>
      </div>
      <Footer />
    </>
  );
};

const PaymentCard = ({ paymentInfo, orderId, onPay, onExpired }) => {
  return (
    <div className="card payment-card">
      <div className="payment-card__text">
        Complete payment before {paymentInfo.expireTime} to secure your booking.
      </div>
      <div className="payment-card__action">
        <Button
          className="pay-btn"
          onClick={() => onPay && onPay(orderId, "esim")}
        >
          <span>Pay</span>
          <CountdownText
            timeoutInSeconds={paymentInfo.timeout}
            onFinished={onExpired}
          />
        </Button>
      </div>
    </div>
  );
};

const VerificationCard = ({ kycInfo, orderId, onPay }) => {
  return (
    <div className="card verification-card">
      <div className="verification-card__title">
        {kycInfo.kycStatus}
      </div>
      <div className="verification-card__text">
        {kycInfo.message}
      </div>
      <div className="verification-card__action">
        {('Verification required' === kycInfo.kycStatus || 'Verification failed' === kycInfo.kycStatus) && (
          <Button
          className="verify-btn"
          onClick={() => onPay && onPay(orderId, "esim")}
        >
          <span>Verify your identity</span>
        </Button>
        )}
      </div>
    </div>
  );
};

const OrderHeaderCard = ({ order }) => {
  const bookingTimeZone = order.timezone || getTimezone() || "UTC";
  const bookingTimestamp = order.createdAt || order.orderDate;
  return (
    <div className="card order-card">
      <div className="order-card__row">
        <div className="order-card__main">
          <div className="order-card__title-row">
            <h2 className="card-title">Booking Information</h2>
            {!order.kycInfo && (
              <span className="order-card__status">{order.status}</span>
            )}
          </div>
          <div className="order-card__meta">
            <div className="order-card__meta-item">
              Order No. {customerOrderNumber(order)}
            </div>
            <div className="order-card__meta-item">
              Booking Date: {formatBookingDate(bookingTimestamp, true, bookingTimeZone) || "Not available"}
              <small className="order-card__timezone">Displayed in {bookingTimeZone}</small>
            </div>
          </div>
          {/* <div className="order-card__amount">
            Total <span>{order.displayAmount}</span>
          </div> */}
        </div>
      </div>
    </div>
  );
};

const PlanInfoCard = ({ order }) => {
  const canShowCoverageSheet = (order.coverage || 0) > 1;
  const [showEsimLocationDialog, setShowEsimLocationDialog] = useState(false);

  return (
    <div className="card plan-card">
      <div className="card-title">Plan Information</div>

      <div className="plan-card__plan-name">{order.planName || ""}</div>

      {canShowCoverageSheet ? (
        <div className="info-row">
          <div className="info-row__label">Coverage:</div>
          <div className="info-row__value">
            <button
              className="link-button"
              onClick={() =>
                setShowEsimLocationDialog(true)
              }
            >
              <span>{order.displayCoverage}</span>
              <span className="link-button__icon">›</span>
            </button>
          </div>
        </div>
      ) : (
        <InfoRow label="Coverage:" value={order.displayCoverage} />
      )}

      <InfoRow label="Data:" value={order.displayVolume} />
      <InfoRow label="Validity:" value={order.displayValidity} />

      <EsimLocationDialog
          className="esim-detail-location-dialog"
          open={showEsimLocationDialog}
          onClose={() => setShowEsimLocationDialog(false)}
          countries={order.networkList}
        />
    </div>
  );
};

const EsimInfoCard = ({ esimProfile, percent }) => {
  return (
    <div className="card esim-card">
      <div className="card-title">Data Information</div>

      <div className="esim-card__status-row">
        <div className="esim-card__status-pill">
          <span
            className={
              esimProfile.status === "New" || esimProfile.status === "Enabled"
                ? "status-pill status-pill--success"
                : "status-pill status-pill--danger"
            }
          >
            {esimProfile.status}
          </span>
        </div>

      </div>

      <InfoRow label="ICCID:" value={esimProfile.iccid} />

      {esimProfile.expiredTime &&
        (!esimProfile.validPeriod || esimProfile.validPeriod.length === 0) && (
          <InfoRow label="Valid Until:" value={esimProfile.expiredTime} />
        )}

      {esimProfile.validPeriod && esimProfile.validPeriod.length > 0 && (
        <InfoRow label="Validity Period:" value={esimProfile.validPeriod} />
      )}

      {typeof esimProfile.remainingTime === "number" && (
        <InfoRow
          label="Time Remaining:"
          value={formatRemainingTime(esimProfile.remainingTime)}
        />
      )}

      <div className="esim-card__usage-block">
        <div className="esim-card__usage-title">Data Usage:</div>
        <div className="esim-card__usage-text">
          {esimProfile.displayUsedVolume} / {esimProfile.displayTotalVolume}
        </div>

        <div className="progress">
          <div
            className="progress__bar"
            style={{ width: `${percent * 100}%` }}
          />
        </div>

        <div className="esim-card__note">
          <strong>Note: </strong>
          <span>Data usage may be delayed by </span>
          <strong>2–3 hours</strong>.
        </div>
      </div>
    </div>
  );
};

const EsimActivationCard = ({ esimProfile }) => {
  return (
    <div className="card esim-card esim-activation-card">
      <div className="esim-activation-card__header">
        <div>
          <div className="card-title">eSim Activation QR</div>
          {/* <div className="esim-activation-card__subtitle">
            Follow the steps below to install your eSim.
          </div> */}
        </div>
        {/* <QuestionCircleOutlined className="esim-activation-card__help-icon" /> */}
      </div>

      <div className="esim-activation-card__tabs">
        <div className="esim-activation__tab">
          <div className="esim-activation__qr-wrapper">
            <div className="esim-activation__qr-card">
              {esimProfile.qrCodeUrl ? (
                <img
                  src={esimProfile.qrCodeUrl}
                  alt="eSIM QR"
                  className="esim-activation__qr-image"
                />
              ) : (
                <div className="esim-activation__qr-placeholder">
                  <QrcodeOutlined />
                  <span>No QR Code</span>
                </div>
              )}
            </div>
          </div>

          {/* <div className="esim-activation__section-title">Install eSim</div> */}

          {/* <div className="esim-activation__article">
        {loadingQr ? (
          <div className="esim-activation__loading">
            <Spin />
          </div>
        ) : qrArticleHtml ? (
          <div
            className="esim-activation__html"
            dangerouslySetInnerHTML={{ __html: qrArticleHtml }}
          />
        ) : (
          <Text type="secondary">
            No installation steps available for QR method.
          </Text>
        )}
      </div> */}
        </div>
      </div>
    </div>
  );
};

const OrderPriceCard = ({ order}) => {
  return (
    <div className="card esim-card">
      <div className="total-price-info-row">
        <div className="total-price-info-row__label">{order.priceInfo.totalPrice.title}</div>
        <div className="total-price-info-row__value">{order.priceInfo.totalPrice.content}</div>
      </div>
      
      <Divider dashed />

      {order.priceInfo.priceDetails.map((priceDetail, index) => (
        <div className="price-info-row" key={`${priceDetail.title}-${index}`}>
          <div className="price-info-row__label">{priceDetail.title}</div>
          <div className="price-info-row__value">{priceDetail.content}</div>
        </div>
      ))}
    </div>
  );
};

const InfoRow = ({ label, value }) => {
  if (!value) return null;
  return (
    <div className="info-row">
      <div className="info-row__label">{label}</div>
      <div className="info-row__value">{value}</div>
    </div>
  );
};

function formatRemainingTime(seconds) {
  if (seconds <= 0) return "Expired";
  const hrs = Math.floor(seconds / 3600);
  const mins = Math.floor((seconds % 3600) / 60);
  if (hrs > 0) return `${hrs}h ${mins}m`;
  return `${mins}m`;
}
